import { z } from "zod";

export const refundSchema = z.object({
  transaction_identifier: z.string({ message: 'Campo obrigatório' }),
  reason: z.string({ message: 'Campo obrigatório' }).min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
  consumption_password: z.string().optional(),
});

export type RefundValidationSchema = z.infer<typeof refundSchema>;
